import { useCallback } from 'react';
// import {
//   useInvalidateFilePreviewQueries,
//   useInvalidateFilesQueries,
//   useInvalidateFolderQueries,
// } from '@/utils/api';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import { WorkspaceObjectType } from '@/enums';
import { BaseObjectAccessContainer } from './BaseObjectAccessContainer';
import { useObjectAccessState } from './hooks';
import type { ObjectAccess as OA } from './interfaces';
import { ObjectAccessState } from './ObjectAccessState';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Props =
  IWorkspaceObjectId &
  IWorkspaceId &
  ChildrenProps;

const ObjectAccessContainer = (props: Props) => {

  // const invalidateFileQueries = useInvalidateFilesQueries();
  // const invalidateFilePreviewQueries = useInvalidateFilePreviewQueries();
  // const invalidateFolderQueries = useInvalidateFolderQueries();

  const [state] = useObjectAccessState();

  const apiClient = useChatApiClient();

  const fetchAccess = useCallback(() => {
    return apiClient.workspacesObject.getObjectAccess({
      objectId: props.objectId,
      workspaceId: props.workspaceId,
    });
  }, [
    apiClient,
    props.objectId,
    props.workspaceId,
  ]);

  const saveAccess = useCallback((data: OA.SaveAccessParams) => {
    return apiClient.workspacesObject.saveObjectAccess({
      items: data.items,
      objectId: props.objectId,
      workspaceId: props.workspaceId,
    }).then(res => {

      // invalidateFileQueries();

      // if (state.object.typeId === WorkspaceObjectType.File) {
      //   invalidateFilePreviewQueries({
      //     fileId: state.object.entityId,
      //   });
      // } else if (state.object.typeId === WorkspaceObjectType.Folder) {
      //   invalidateFolderQueries({
      //     folderId: state.object.entityId,
      //   });
      // }

      Toast.alert({
        title: `Access Updated`,
      });
    }).catch(e => {
      Toast.error({
        title: 'Error',
        body: `We're sorry, there was an issue updating access`,
      });
    });
  }, [
    // invalidateFileQueries,
    // invalidateFilePreviewQueries,
    // invalidateFolderQueries,
    apiClient,
    props.objectId,
    props.workspaceId,
    state.object,
  ]);

  const fetchGroupUsers: OA.FetchGroupUsers = useCallback(data => {
    return apiClient.groups.getGroupUsers({
      allGroups: false,
      ...data,
    });
  }, [apiClient]);

  const containerProps = {
    fetchAccess,
    fetchGroupUsers,
    saveAccess,
  };

  return (
    <BaseObjectAccessContainer {...containerProps}>
      {props.children}
    </BaseObjectAccessContainer>
  );
};

const WithState = (props: Props) => {

  return (
    <ObjectAccessState>
      <ObjectAccessContainer {...props} />
    </ObjectAccessState>
  );
};

export { WithState as ObjectAccessContainer };